export const SET_ASYNC_DEPENDENCIES_LOADING = 'asyncDependencies/SET_ASYNC_DEPENDENCIES_LOADING';
export const SET_ASYNC_DEPENDENCIES_SUCCESS = 'asyncDependencies/SET_ASYNC_DEPENDENCIES_SUCCESS';
export const SET_ASYNC_DEPENDENCIES_ERROR = 'asyncDependencies/SET_ASYNC_DEPENDENCIES_ERROR';
